const header = {
  header: {
    logOut: 'Uitloggen',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Enphase Support',
    comingSoon: 'Komt binnenkort',
    new: 'Nieuw'
  }
};

export default header;
